<div class="container-fluid">
    <app-submenu-tabs section="ONBOARDINGSTATUS"></app-submenu-tabs>
    <router-outlet></router-outlet>    
</div>